/**
 * Created by hernanherreros on 2019-06-27
 */

import * as React from 'react'
import styled from 'styled-components'
import ActivitiesContext from './ActivitiesContext'
import { Trans } from '@lingui/macro'
import FlipMove from 'react-flip-move'
import ActivityCartCard from './ActivityCartCard'

interface Props {
}

interface State {
}

export default class ActivitiesCart extends React.Component<Props, State> {
  static contextType = ActivitiesContext

  getActivity = (id: number) => {
    const { activities } = this.context

    return activities.find((a: any) => a.ID === id) || {}
  }

  getActivities = () => {
    const { selectedActivities } = this.context

    return selectedActivities.map(this.getActivity)
  }

  render() {
    return (
      <Container>
        {this.renderActivities()}
        {this.renderPlaceholder()}
      </Container>
    )
  }

  renderActivities () {
    const { selectedActivities, isLoading, activities } = this.context

    if (selectedActivities.length && !isLoading && activities.length > 0) {
      return (
        <Wrapper>
          <Title>
            <Trans>Actividades Seleccionadas</Trans>
          </Title>
          <FlipMove { ...flipMoveOptions }>
            {this.getActivities().reverse().map((a: any) => (
              <CardWrapper key={a.ID}>
                <ActivityCartCard id={a.ID}/>
              </CardWrapper>
            ))}
          </FlipMove>
        </Wrapper>
      )
    }
  }

  renderPlaceholder () {
    const { selectedActivities, isLoading, activities } = this.context

    if (!selectedActivities.length || isLoading || activities.length === 0) {
      return (
        <PlaceholderWrapper>
          <span>
            <Trans>Seleccione alguna actividad</Trans>
          </span>
          <small>
            <Trans>Acá podrá ver las actividades seleccionadas</Trans>
          </small>
        </PlaceholderWrapper>
      )
    }
  }
}

const enterAnimation = {
  from: {
    transform: 'translateY(-10px)',
    opacity: 0.1,
  },
  to: {
    transform: 'translateY(0)',
    opacity: 1,
  },
}

const flipMoveOptions: any = {
  easing: 'cubic-bezier(0.19, 1, 0.22, 1)',
  duration: 700,
  enterAnimation: enterAnimation,
  leaveAnimation: 'fade',
}

const Container = styled.div`
  display: block;
  position: relative;
  width: 100%;
  min-height: 500px;
  background-color: #f5f7f9;
  border-radius: 10px;
`

const Wrapper = styled.div`
  padding: 20px;
`

const Title = styled.h3`
  color: #444;  
`

const CardWrapper = styled.div`
  margin: 16px 0; 
`

const PlaceholderWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #444;
  font-weight: 300;
  padding: 20px;
  text-align: center;
  
  span {
    font-size: 18px;
  }
`